import { default as l } from "./FloatingUi.vue2.js";
import { default as i } from "./FocusTrap.vue2.js";
import t from "./AutoWrap.vue2.js";
import { default as d } from "./PassThrough.vue2.js";
import { default as c } from "./Sort.vue2.js";
import { default as y } from "./SortBy.vue2.js";
import { default as T } from "./TeleportCopy.vue2.js";
import { default as g } from "./Wrap.vue2.js";
function a(r) {
  var o, e;
  return typeof r == "object" && ((e = (o = r.$) == null ? void 0 : o.vnode) == null ? void 0 : e.type) === t;
}
function p(r) {
  return a(r) ? r.el : r;
}
export {
  t as AutoWrap,
  l as FloatingUi,
  i as FocusTrap,
  d as PassThrough,
  c as Sort,
  y as SortBy,
  T as TeleportCopy,
  g as Wrap,
  a as isOverridableWrapper,
  p as resolveOverridableComponent
};
